import type { ApmBase, Transaction } from "@elastic/apm-rum";
import { grScope } from "@gr-common/async/logger";

export const apmAsyncScope = grScope.scope("apm");

/*                                            */
export const knownFields = ["transactions", "errors"] as const;
export const transactionTypes = ["page-load", "http-request"] as const;
export type TransactionType = (typeof transactionTypes)[number];

export type APMTransactionPayload = {
  name?: string;
  sampled?: boolean;
  span_count?: { started: number };
  spans?: SpanPayload[];
  type: string;
  context?: ContextPayload;
};

export type ContextPayload = {
  tags?: Labels;
  custom?: Labels;
  page?: Labels;
};

export type SpanPayload = {
  type?: string;
  subtype?: string;
  action?: string;
  name?: string;
  context?: ContextPayload;
};

export type APMErrorPayload = {
  id?: string;
  context?: ContextPayload;
  exception?: {
    type?: string;
    message?: string;
    stacktrace?: {
      abs_path?: string;
      filename?: string;
    }[];
  };
};

export type APMPayload = {
  transactions?: Partial<APMTransactionPayload>[];
  errors?: Partial<APMErrorPayload>[];
  /*                                                          */
  [key: string]: any;
};

export type FilterCb = (payload: APMPayload) => Payload | boolean | void;

export const defineFilterCb = (
  cb: (payload: APMPayload) => APMPayload | Payload | boolean | void,
): FilterCb => cb as never;

/**
 *
 *
 */
export type NoOps = [noopNull: () => null, noopUndefined: () => undefined];

/**
 *
 *
 */
export const noops: NoOps = [() => null, () => undefined];

/**
 *
 *
 *
 *
 *
 */
export const withTransaction =
  <R, A extends unknown[]>(
    agent: ApmBase,
    withCb: (transaction: Transaction, ...args: NoInfer<A>) => R,
  ): ((...args: A) => R) =>
  (...a) => {
    const transaction = agent.getCurrentTransaction();
    return transaction ? withCb(transaction, ...a) : (undefined as R);
  };
